var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Notice Of Intention To Leave"}}),_c('ContentRow',[_c('ContentContainer',[_c('Form',{attrs:{"type":"Generic.AU.QLD.Form13Graphical"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }